import React from "react";
import { 
  useAuthenticator, 
} from "@aws-amplify/ui-react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//import { ProgramTitle } from "./ProgramTitle";
import ProgramTitleAuth from "./ProgramTitleAuth";
//import { NextEventDateInfo } from "./NextEventDateInfo";
//import { AuthNav } from "./AuthNav";
import { Flex } from "reflexbox";
import  CastNCarry  from "../CastNCarry/CastNCarry";
//import MuxVideoPlayer from "../MuxPlayer/MuxPlayerNew";
//import  CastNCarrySubscribe  from "../CastNCarry/CastNCarrySubscribe";
//import { EventDateInfo } from "../components/EventDateInfo";
//import AuthNavExtend from "./AuthNavExtend";
import '@fontsource/inter/variable.css';
import "../App.css";

export function WatchProgram() {
  const { route } = useAuthenticator((context) => [context.route]);

  const message =
    route === "authenticated" ? " " : "Loading...";
  return <div level={1}>
  {message}
    <div className="WrappedContent">
      <Container fluid className="AppContainerContent">
       {/***PROGRAM INFO***/}
         {/* */}
          <Row className="eventDate">
          <Col className="ProgramInfo">
            <ProgramTitleAuth />
          </Col>
        </Row>
        {/***PROGRAM***/}
        <Flex
          mt="100px"
          alignItems="flex-start"
          //width={1}
          style={{ border: "1px solid #0033FF" }}
          >
          <Flex width="100%">
            <CastNCarry />
          </Flex>
        </Flex>
      </Container>
    </div>
  </div>;
}

